export class IdentityConstants {
    public static getUserProfileUrl = 'retail-account/retail-accounts/userinfo';
}
